"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

exports.numberWithCommas = numberWithCommas;

exports.displayLocation = function (location) {
  return "" + (location.address ? location.address + ", " : "") + location.city + (location.state ? ", " + location.state : "");
};

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 8; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

exports.makeId = makeId;

exports.getInitials = function (title) {
  try {
    return title.split(" ").map(function (word) {
      return word[0];
    }).join("").toUpperCase().slice(0, 2);
  } catch (error) {
    return "";
  }
};

exports.genIndices = function (by, objects) {
  var indices = {};

  for (var i = 0; i < objects.length; i++) {
    var object = objects[i];
    indices[object[by]] = i;
  }

  return indices;
};

__export(require("./price"));

__export(require("./chat"));

__export(require("./phone"));

__export(require("./venue"));

__export(require("./booking"));

__export(require("./user"));